import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { DataComponent } from '../types/Components';

/**
 * A component that tracks an entity's energy for turn-based gameplay.
 */
class TakesTurns extends Component implements DataComponent {
  energy: number;

  constructor(data: { energy?: number } = {}) {
    super();
    this.energy = data.energy ?? 0;
  }
}

export default simpleComponent(TakesTurns);
